import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import StaticField from './StaticField';

interface CarModelFieldProps {
    carModel: string;
    count: number;
    price: number;
}

const GridLongCell = styled.div`
    border: 1px solid rgb(206, 212, 218);
    padding: 0px 15px;
    grid-column: span 2 / auto;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: justify;
    justify-content: space-between;
    min-height: 60px;
    -webkit-box-align: center;
    align-items: center;
`;

const VariantField = styled(StaticField)<{ editable: boolean }>`
    border: none;
    padding: 0px;
    width: 50%;
    span:nth-child(1) {
        text-align: start;
        font-size: 1rem;
        color: ${props => (props.editable ? props.theme.antd['primary-color'] : props.theme.antd['text-color'])};
    }
    span:nth-child(2) {
        text-align: start;
        font-size: 0.65rem;
        align-items: center;
        color: ${props => props.theme.antd['text-color']};
    }
`;

const StartingPriceField = styled(StaticField)<{ editable: boolean }>`
    border: none;
    padding: 0px;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    span:nth-child(1) {
        width: 30%;
        height: 40px;
        white-space: normal;
        overflow: initial;
    }
`;

const CarModelField = (props: CarModelFieldProps) => {
    const { carModel, count, price } = props;
    const { t } = useTranslation(['calculation']);

    return (
        <GridLongCell>
            <VariantField label={carModel} size={1} value={t('calculation:labels.inStock', { count })} editable />
            <StartingPriceField
                label={t('calculation:labels.startingPrice')}
                size={1}
                value={t('calculation:labels.currency', { price })}
                editable
            />
        </GridLongCell>
    );
};

export default CarModelField;
